export const generate_variable_options = (basic_variable_options, table_data) => {    
    const _set_option_array = (item) => {
        const { json_key, default_value } = item
        const get_row_value = row => row[json_key];
        const all_value = table_data.map(get_row_value);
        const option_array = default_value ? [default_value, ...new Set(all_value)] : [...new Set(all_value)];
        return { ...item, option_array }
    }
    
    const _set_value = (option) => {
        const _judge_selected_value_in_options = (option) => {
            const { option_array, current_option_value } = option;
            return option_array.includes(current_option_value)
        }
        
        const { current_option_value } = option
        const is_need_set_value = !current_option_value || _judge_selected_value_in_options(option)
        if (is_need_set_value) {
            const { default_value, option_array } = option
            const value_be_assigned = default_value ? default_value : option_array[0]
            return _change_current_option_value(option, value_be_assigned)
        }
        
        return option
    }
    return basic_variable_options
        .map(_set_option_array)
        .map(_set_value)
}

export const update_option_set_from_local_storage = (option_set, local_storage_option_name) => {
    const record_option_value_obj = JSON.parse(localStorage.getItem(local_storage_option_name))
    if (record_option_value_obj && Object.keys(record_option_value_obj).length !== 0) {
        const update_current_value_from_local_storage = update_current_option_value(record_option_value_obj)
        return option_set.map(update_current_value_from_local_storage)
    }
    return option_set
}

export const update_current_option_value = (all_option_value) => {
    return (option) => {
        const { label, option_array } = option
        const be_updated_value = all_option_value[label]
        if (be_updated_value && option_array.includes(be_updated_value)) {
            return _change_current_option_value(option, be_updated_value)
        }
        return option
    }
}

const _change_current_option_value = (option, new_value) => {
    return { 
        ...option, 
        current_option_value: new_value 
    }
}

export const combine_new_variable_options = (option_set, variable_options) => {
    const assign_changed_option = (option) => {
        const new_option = variable_options.find(({ label }) => label === option.label)
        return new_option ?? option
    }

    return option_set.map(assign_changed_option)
}

export const new_filter_unit_function = (option_value, cell_key, display_all_name, ) => {
    const _judge_value_display_all = (item , compared_display_value) => item === compared_display_value
    const _judge_table_value_include_compare_value = (table_value, compare_value) => table_value.includes(compare_value)
    
    return item => {
        const table_value = item[cell_key] ?? ''
        const is_display_all = _judge_value_display_all(option_value, display_all_name)
        const filter_result = _judge_table_value_include_compare_value(table_value, option_value)
        return is_display_all ? is_display_all : filter_result    
    }
}